import { Flex, Icon, IconButton } from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import icons from 'shared/icons';
import { iconTableStyle, tableToolbarStyle } from 'shared/styles';
import GlobalFilter from 'plugins/DITable/filters/GlobalFilter';
import { TProductDetailsHooks } from './useProductDetails';
import { DeleteIcon } from '@chakra-ui/icons';
import ARetLangSelector from 'components/atoms/ARetLangSelector';
import { WeeklyCalendar } from 'components/molecules/WeeklyCalendar';
import { useEffect, useState } from 'react';

interface IColorsToolbarProps {
    table: Table<any>;
    isPDPLoading: TProductDetailsHooks['isPDPLoading'];
    handleOpenModal: TProductDetailsHooks['handleOpenModal'];
    setDataToSubmit: TProductDetailsHooks['setDataToSubmit'];
    handleDelete: TProductDetailsHooks['handleDelete'];
    isExportLoading: TProductDetailsHooks['isExportLoading'];
    isExportFetching: TProductDetailsHooks['isExportFetching'];
    handleExportPDPs: TProductDetailsHooks['handleExportPDPs'];
    retailer: TProductDetailsHooks['retailer'];
    setRetailer: TProductDetailsHooks['setRetailer'];
    lang: TProductDetailsHooks['lang'];
    setLang: TProductDetailsHooks['setLang'];
    selectedPDPs: TProductDetailsHooks['selectedPDPs'];
    dateInWeeks: TProductDetailsHooks['dateInWeeks'];
    setDateInWeeks: TProductDetailsHooks['setDateInWeeks'];
    pdpData: TProductDetailsHooks['pdpData'];
    readonly: boolean;
    todaysDate: TProductDetailsHooks['todaysDate'];
    limitedAccess?: boolean;
}

const PDPToolbar = ({
    table,
    isPDPLoading,
    handleOpenModal,
    setDataToSubmit,
    isExportLoading,
    isExportFetching,
    handleExportPDPs,
    retailer,
    setRetailer,
    pdpData,
    lang,
    setLang,
    selectedPDPs,
    handleDelete,
    dateInWeeks,
    setDateInWeeks,
    todaysDate,
    readonly,
    limitedAccess
}: IColorsToolbarProps) => {
    const { setGlobalFilter } = table;
    const PlusIcon = icons.plus;
    const DownloadIcon = icons.download;
    const [disableButtons, setDisableButtons] = useState(false);

    useEffect(() => {
        if (readonly || (limitedAccess && (todaysDate.current.week !== dateInWeeks.week || todaysDate.current.year !== dateInWeeks.year)))
            setDisableButtons(true);
        else setDisableButtons(false);
    }, [readonly, limitedAccess, dateInWeeks]);


    return (
        <Flex {...tableToolbarStyle} justifyContent="space-between" alignItems="center">
            <Flex>
                <GlobalFilter globalFilter={table.getState().globalFilter} setGlobalFilter={setGlobalFilter} />
                <IconButton
                    onClick={() => {
                        setDataToSubmit({
                            week: dateInWeeks.week?.toString().padStart(2, '0') + '_' + dateInWeeks.year,
                        });
                        handleOpenModal('add');
                    }}
                    {...iconTableStyle}
                    aria-label="add pdp"
                    isDisabled={isPDPLoading || disableButtons}
                    size="sm"
                    icon={<Icon as={PlusIcon} />}
                />
                <IconButton
                    {...iconTableStyle}
                    aria-label="download excel"
                    isLoading={isExportLoading || isExportFetching}
                    isDisabled={!pdpData?.length}
                    onClick={handleExportPDPs}
                    size="sm"
                    icon={<DownloadIcon />}
                />
                <IconButton
                    size="sm"
                    isDisabled={selectedPDPs.length === 0 || disableButtons}
                    {...iconTableStyle}
                    onClick={() => handleDelete(true)}
                    aria-label="bulk delete"
                    icon={<Icon as={DeleteIcon} />}
                />
            </Flex>
            <Flex>
                <ARetLangSelector
                    selectedRetailer={retailer}
                    selectedLang={lang}
                    setSelectedLang={setLang}
                    setSelectedRetailer={setRetailer}
                    omitLang
                />
                <WeeklyCalendar
                    dateInWeeks={dateInWeeks}
                    setDateInWeeks={setDateInWeeks}
                    style={{ marginLeft: '10px' }}
                />
            </Flex>
        </Flex>
    );
};

export default PDPToolbar;
